import React from 'react'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import Button from '../Button'
import styles from './styles.module.css'
import { profileValues, OTHER_PROFILE } from './constants'

function NewsletterForm({ 
  onSubmit,
  isLoading,
  isSubmitted,
  onChangeEmail,
  onChangeName,
  profile,
  onChangeProfile,
  onChangeOtherProfile,
  isInvalidEmail
}) {
  const { t } = useTranslation()

  return (
    <form onSubmit={onSubmit}>
      <div className={styles.newsletterFormGroup}>
        <label>
          {t('newsletter.form.emailField')}
          <input
            className={`hot-form__input ${isSubmitted && !isLoading && isInvalidEmail && 'is-invalid'}`}
            type="text"
            name="email"
            onChange={onChangeEmail}
            data-testid="field-email"
            disabled={isLoading}
          />
          <div className="invalid-feedback" data-testid="invalid-feedback">
            {t(isInvalidEmail)}
          </div>
        </label>
        <label>
          {t('newsletter.form.nameField')} <span>{t('newsletter.form.optional')}</span>
          <input
            className="hot-form__input"
            type="text"
            name="name"
            onChange={onChangeName}
            data-testid="field-name"
            disabled={isLoading}
          />
        </label>
        <label className={styles.selectInput}>
          {t('newsletter.form.profileField')} <span>{t('newsletter.form.optional')}</span>
          <Select
            components={{
              IndicatorSeparator: () => null,
            }}
            data-testid="field-select-profile"
            isSearchable={false}
            placeholder={t('newsletter.form.profilePlaceholder')}
            onChange={onChangeProfile}
            options={profileValues(t)}
          />
        </label>

        {profile === OTHER_PROFILE && (
          <label>
            {t('newsletter.form.otherProfileField')} <span>{t('newsletter.form.optional')}</span>
            <input
              className="hot-form__input"
              type="text"
              name="name"
              onChange={onChangeOtherProfile}
              data-testid="field-other-profile"
              disabled={isLoading}
            />
          </label>
        )}

        <Button isLoading={isLoading} loadingLabel={t('newsletter.form.registering')} data-testid="submit-button">
          {t('newsletter.form.cta')}
        </Button>
      </div>
    </form>
  )
}

export default NewsletterForm
